const initialState = [];

export const watchLiveChannels = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_WATCH_LIVE_CHANNELS':
        return action.payload;
    default:
      return state;
  }
}